module.exports = __webpack_public_path__ + "static/blurDescription@2x-37ba75fd13477429205f8e8ced11ff6c.png";